import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BillingApiController } from '../../api-controllers/billing.api-controller';
import { v4 as uuid } from 'uuid';
import { StripeManager } from '../../managers/stripe.manager';
import { AuthService } from '@auth0/auth0-angular';

declare global {
  interface Window {
    Stripe: any;
  }
}


@Component({
  selector: 'app-license-suspended-modal',
  templateUrl: './create-payment-method-modal.component.html',
  styleUrls: ['./create-payment-method-modal.component.scss'],
  standalone: false,
})
export class CreatePaymentMethodModalComponent implements OnInit {

  paymentCardElement: any;

  stripe: any;

  stripeElements: any;

  isCreditCardDisabled = false;

  public idempotencyKey: string;

  constructor(public activeModal: NgbActiveModal,
              public readonly translateService: TranslateService,
              public readonly billingApiController: BillingApiController,
              private readonly stripeManager: StripeManager,
              public auth: AuthService,
  ) {
  }

  async ngOnInit() {
    this.idempotencyKey = uuid();
    const response = await this.billingApiController.setupSubscription(this.idempotencyKey);

    const options = {
      clientSecret: response.client_secret,
      // Fully customizable with appearance API.
      appearance: {},
    };

    this.auth.user$.subscribe(user => {
      // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 3
      this.stripe = window.Stripe(this.stripeManager.getPublishableKey(user.email), { locale: this.translateService.currentLang });
      this.stripeElements = this.stripe.elements(options);

      // Create and mount the Payment Element
      this.paymentCardElement = this.stripeElements.create('payment');
      this.paymentCardElement.mount('#payment-element');
    });
  }

  async createPaymentMethod() {
    const messageContainer = document.querySelector('#message');
    this.isCreditCardDisabled = true;

    try {
      const { error, paymentIntent } = await this.stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements: this.stripeElements,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: 'if_required',
      });


      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)

        messageContainer.textContent = error.message;
        messageContainer.classList.add('alert-danger');
        this.isCreditCardDisabled = false;

      } else {
        messageContainer.textContent = 'Carte de crédit ajoutée avec succès.';
        messageContainer.classList.add('alert-success');
        // handleOther();
      }

    } catch (error) {
      messageContainer.textContent = error;
      messageContainer.classList.add('alert-danger');
      this.isCreditCardDisabled = false;
      // handleOther();
    } finally {
      messageContainer.classList.remove('visually-hidden');

      setTimeout(() => {
        this.activeModal.close();
      }, 1500);
    }


  }

}
